import React, { useEffect, useState } from 'react';
import axios, { all } from 'axios';
import InvoiceItem from './components/invoiceItem';
import { useNavigate } from 'react-router-dom';
import LoadingSpinner from './components/LoadingSpinner';
import './customerInvoices.css';
import { getPrevMonthStartDate, getPrevMonthEndDate, formatDateToZoho } from './components/utils';
import { writeFileXLSX,utils } from 'xlsx';
import { isAuthTokenValid } from './components/utils';

const BulkUpdate = ({pageSize,markSent,toggleGetInvoices}) => {
  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [dateRangeText, setDateRangeText] = useState('');

  const orgID = '837447409';
  const serverURL = process.env.REACT_APP_SERVER_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
     fetchAllInvoices();
  }, [pageSize,toggleGetInvoices]);

  useEffect(() => {
      setIsLoading(true);
      setProgress(0);
      markBatchSent();
  }, [markSent])

  const markBatchSent = async () => {
    setProgress(0);
    setIsLoading(true);
    let completedCount = 0;
    const updatedInvoices = [];
    //check if the token is still valid
    if (!isAuthTokenValid()) {
      navigate('/authentication');
      return;
    }       
    const accessToken = localStorage.getItem('access_token');

    for (const invoice of invoices) {
        try {
            // Make a POST request to your server's endpoint to mark the invoice as sent
            console.log('Invoice ID: ',invoice.invoice_id);
            //const body = '{"invoice_id":"'+invoice.invoice_id+'"}';
            const { invoice_id } = invoice;
            const response = await axios.post(serverURL+'/set-invoice-sent', { invoice_id, accessToken }, {
              headers: {
                  'Content-Type': 'application/json',
              }});
            
            if (response.status >= 200 && response.status < 300) {
                // Update the invoice object with the processed property
                const updatedInvoice = { ...invoice, processed: true };
                updatedInvoices.push(updatedInvoice); // Add updated invoice to the array
                
                completedCount++;
                setProgress(completedCount / invoices.length * 100);
            } else {
                console.error('API error:', response.status, response.statusText);
            }
        } catch (error) {
            console.error('Error setting invoice as sent:', error);
        }
    }
    setInvoices(updatedInvoices); // Update the state with the processed invoice
    setIsLoading(false);
};



  const fetchAllInvoices = async () => {
    const accessToken = localStorage.getItem('access_token');
    const preferences = JSON.parse(localStorage.getItem('userPreferences'));
    let startDate = getPrevMonthStartDate();
    let endDate = getPrevMonthEndDate();
    let status = 'draft';
    // overide default values if user changed them
    if (preferences) {
        startDate =  preferences.startDate || '';
        endDate = preferences.endDate || '';
        status = preferences.invoiceStatus || 'draft';
      }
     setDateRangeText(formatDateToZoho(startDate)+' - '+formatDateToZoho(endDate));
    if (!isAuthTokenValid()) {
        navigate('/authentication');
        return; // Stop further execution
    }
    let allInvoices = [];
    let hasMorePages = true;
    let pageNumber = 1;
    console.log('The page size is,',pageSize,' and invoice l, ',allInvoices.length);
    while (hasMorePages && pageSize > allInvoices.length) {
      const { returnedInvoices, hasMorePages: nextPage } = await fetchData(pageNumber,startDate,endDate,accessToken);
      allInvoices = [...allInvoices, ...returnedInvoices];
      hasMorePages = nextPage;
      pageNumber++;
      setProgress(allInvoices.length/pageSize * 100);
    }
    setProgress(100);
    setInvoices(allInvoices);
  };

  const fetchData = async (pageNumber = 1,startDate,endDate,accessToken) => {
    
    try {
      let params = {
        organization_id: orgID,
        page: pageNumber, // Pass the page number parameter
        status: 'draft',
        per_page:pageSize,
      };
  
      // Check if startDate and endDate preferences are stored
      if (startDate && endDate) {
        params.date_start = startDate;
        params.date_end = endDate;
      }
  
      console.log('start date:', startDate, ' end date: ', endDate);
      const response = await axios.get(serverURL+'/getInvoices', {
        params: params,
        headers: {
          Authorization: 'Zoho-oauthtoken '  + accessToken,
        },
      });
  
      if (response.status >= 200 && response.status < 300) {
        const responseData = response.data;
        const returnedInvoices = responseData.response.invoices;
        const hasMorePages = responseData.response.page_context.has_more_page;

         return {returnedInvoices,hasMorePages};
 
      } else {
        console.error('API error:', response.status, response.statusText);
        return { returnedInvoices: [], hasMorePages: false };
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      // Reset token data stored in localStorage on error
      localStorage.removeItem('access_token');
      navigate('/authentication');
      return { returnedInvoices: [], hasMorePages: false };
    }
  };

  return (
    <div className="printWrapper">

        <div className="separator"></div>
        <div className="list-invoices">
            {progress == 100 ? (
            <>
            <div id="totalSummary">
                <table className='summaryTotalsTable'>
                    <tbody>
                        <tr>
                            <td>Number of Invoices:</td><td>{invoices.length}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
                
            <table id="mainExportTable" className="summaryTable">
            <thead>
                <tr>
                    <th className='customerCellHeader'>Customer Name</th>
                    <th className='bulkCellHeader'>Date</th>
                    <th className='bulkCellHeader'>Invoice Number</th>
                    <th className='bulkCellHeader'>Invoice ID</th> 
                    <th className='invoiceStatusHeader'>Status</th>
                    <th className="processedHeader">Processed</th>
                </tr>
            </thead>
            <tbody>
            {invoices.map((invoice) => (
              <tr key={invoice.invoice_id}>
                <td className="customerCell">{invoice.customer_name}</td>
                <td className="bulkCell">{invoice.date}</td>
                <td className="bulkCell">{invoice.invoice_number}</td>
                <td className="bulkCell">{invoice.invoice_id}</td>
                <td className="bulkCell">{invoice.status}</td>
                <td className="processedCell">{invoice.processed ? <span className="checkmark">&#10003;</span> : null}</td> 
              </tr>
            ))}
                </tbody>
            </table>
            </>
            ) : (
            <LoadingSpinner progress={progress} /> // Pass the progress to the LoadingSpinner component
            )}
        </div>
    </div>
  );
};

export default BulkUpdate;
